<template>
  <div id="menu-name">
  <FormGroupHorizontal 
      :label="$t('engine.manageFooter.manu.lblMenuName', languageEngine)"
      :labelHint="languageUse.toUpperCase()"
      :labelRequired="true"
      :split="'4:8'"
      :contentClass="{ errors: validate.$error }"
    >
     <b-form-input
        id="header-name"
        @input="handleInput"
        :value="value"
        :placeholder="$t('engine.manageFooter.manu.lblMenuName', languageEngine)"
      ></b-form-input>
    </FormGroupHorizontal>
  <FormGroupHorizontal v-if="validate.$error"
      :label="''"
      :split="'4:8'"
      class="mt-5"
      :contentClass="'errors'"
    >
      <small v-if="!validate.required && validate.$error"> {{$t('engine.manageFooter.menu.validate.lblName', languageEngine)}}</small>
      <small v-else-if="!validate.maxLength && validate.$error"> {{$t('engine.manageFooter.menu.set.validate.lblLongerName', languageEngine)}}</small>
      <!-- <small v-else-if="!validate.alphaName && validate.$error"> {{$t('engine.manageFooter.menu.set.validate.lblAlphabetName', languageEngine)}} </small> -->
    </FormGroupHorizontal>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';


export default {
  props: {
    value: {
      type: String,
    },
    validate : {
    }
  },
  components: {
    FormGroupHorizontal
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss">
label.required::after {
  margin-left: 5px;
  content:"*";
  color:red;
}
</style>